module.exports = __webpack_public_path__ + "static/media/grid.c3bb3613.png";